import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getSupportingContent } from "actions/agents";
import Input from "components/Elements/Input";
import InputField from "components/InputField/InputField";
import Select from "react-select";
import AffirmationsTable from "components/Tables/AffirmationsTable";
import SupportingContentTable from "components/Tables/SupportingContentTable";
import { getSupportingContentWorkflows } from "actions/workflows";
import {
  saveSupportingContent,
  generateSupportingContent,
} from "actions/agents";
import { getActiveUser } from "utils/utils";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";
import styled from "styled-components";

export const ErrorField = styled.span`
  color: red;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

const SupportingContent = () => {
  const activeUser = getActiveUser();
  const { supportingcontent_id } = useParams();
  console.log("!!! SUPPORTING CONTENT ID: ", supportingcontent_id);
  const {
    activeSupportingContent,
    agent,
    savingSupportingContent,
  } = useSelector((state) => state.agents);
  const { supportingContentWorkflows } = useSelector(
    (state) => state.workflows
  );
  const [formErrors, setFormErrors] = useState({});
  const [supportingContent, setSupportingContent] = useState({});
  const [workflowInputParams, setWorkflowInputParams] = useState({});
  const [
    selectedSupportingContentWorkflow,
    setSelectedSupportingContentWorkflow,
  ] = useState(null);
  const [
    supportingContentWorkflowOptions,
    setSupportingContentWorkflowOptions,
  ] = useState([]);
  const dispatch = useDispatch();
  const toast = useRef();
  useEffect(() => {
    dispatch(getSupportingContent(supportingcontent_id));

    // eslint-disable-next-line
  }, [supportingcontent_id]);

  useEffect(() => {
    if (supportingContentWorkflows) {
      const options = [
        { value: "", label: "Choose a Workflow" },
        ...supportingContentWorkflows.map((w) => {
          return { value: w.public_id, label: w.name };
        }),
      ];
      setSupportingContentWorkflowOptions(options);
    } else {
      dispatch(getSupportingContentWorkflows());
    }
    // eslint-disable-next-line
  }, [supportingContentWorkflows]);

  useEffect(() => {
    if (activeSupportingContent) {
      /*if (!agent) {
        dispatch(getAgent(activeSupportingContent.agent_id));
      }*/

      activeSupportingContent.data =
        activeSupportingContent.data &&
        typeof activeSupportingContent.data === "string"
          ? JSON.parse(activeSupportingContent.data)
          : activeSupportingContent.data;
      setSupportingContent(activeSupportingContent);
      const wf = supportingContentWorkflows.find(
        (w) => w.public_id === activeSupportingContent.workflow
      );

      if (wf) {
        setSelectedSupportingContentWorkflow({
          value: wf.public_id,
          label: wf.name,
        });

        setWorkflowInputParams(
          wf.input_params ? JSON.parse(wf.input_params) : {}
        );
      }
    }
    // eslint-disable-next-line
  }, [activeSupportingContent, supportingContentWorkflows, agent]);

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleSupportingContentWorkflowChange = (supportingContentWorkflow) => {
    const m = { ...supportingContent };
    if (supportingContentWorkflow.value === "") {
      setWorkflowInputParams({});
      m.workflow_id = "";
      m.workflow = null;
      setSupportingContent(m);
      setSelectedSupportingContentWorkflow(null);
      return;
    }

    m.workflow_id = supportingContentWorkflow.value;
    m.workflow = supportingContentWorkflows.find(
      (w) => w.public_id === supportingContentWorkflow.value
    );
    setWorkflowInputParams(
      m.workflow.input_params ? JSON.parse(m.workflow.input_params) : {}
    );
    setSupportingContent(m);
    setSelectedSupportingContentWorkflow(supportingContentWorkflow);
  };

  const handleChange = ({ target }) => {
    const u = { ...supportingContent };
    u[target.name] = target.value;
    setSupportingContent(u);
  };

  const handleInputFieldChange = (name, value) => {
    const u = { ...supportingContent };
    u.data[name] = value;
    setSupportingContent(u);
  };

  const displaySupportingContentTypeFields = () => {
    return Object.keys(workflowInputParams).map((key) => {
      const param = workflowInputParams[key];
      return (
        <div key={`inputfield_${key}`}>
          <InputField
            name={key}
            param={param}
            media={agent?.media}
            value={supportingContent.data[key] ?? ""}
            onChange={handleInputFieldChange}
          />
        </div>
      );
    });
  };

  const validateFields = () => {
    setFormErrors({});
    const errors = {};

    const urlValid =
      !supportingContent.url || supportingContent.url.match(/^http(s):\/\/.*$/);
    errors.url = urlValid ? "" : " is invalid";
    const nameValid =
      supportingContent.name && supportingContent.name.length > 0;

    setFormErrors(errors);

    return nameValid;
  };

  const save = () => {
    if (validateFields()) {
      dispatch(saveSupportingContent(supportingContent, agent.public_id));
    }
  };

  if (!supportingContent) {
    return (
      <>
        <Sidebar {...sidebar} />
        <div
          className="relative md:ml-64 bg-blueGray-100 pt-24"
          style={{ height: "100%", minHeight: "100vh" }}
        >
          Loading...
        </div>
      </>
    );
  }

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div className="flex flex-wrap">
            <div className="relative p-6 flex-auto ">
              <div>
                <a href={`/agent/${supportingContent.agent_id}`}>
                  <i className="fa fa-arrow-left" /> Back to{" "}
                  {supportingContent.agent}
                </a>{" "}
              </div>
              <h3 className="font-bold text-lg text-blueGray-700">{`${
                supportingContent.name ?? ""
              }`}</h3>
              <div
                className="my-4 text-blueGray-500 text-lg leading-relaxed"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{ width: "40%", flexShrink: 0, marginRight: "20px" }}
                >
                  <label>ID</label>
                  <Input
                    label="ID"
                    placeholder="ID"
                    name="id"
                    value={supportingContent.id ?? ""}
                    disabled
                  />
                </div>
                <div
                  style={{ width: "40%", flexShrink: 0, marginRight: "20px" }}
                >
                  <label>Public ID</label>
                  <Input
                    label="Public ID"
                    placeholder="Public ID"
                    name="public_id"
                    value={supportingContent.public_id ?? ""}
                    disabled
                  />
                </div>
                <div
                  style={{ width: "40%", flexShrink: 0, marginRight: "20px" }}
                >
                  <label>Name</label>
                  <Input
                    label="Name"
                    placeholder="Name"
                    name="name"
                    value={supportingContent.name ?? ""}
                    onChange={handleChange}
                  />
                </div>
                <div
                  style={{ width: "40%", flexShrink: 0, marginRight: "20px" }}
                >
                  <label>
                    Content Support Workflow{" "}
                    <ErrorField>{formErrors.workflow}</ErrorField>
                  </label>
                  <Select
                    label="Workflow"
                    placeholder="Choose a Workflow"
                    name="workflow"
                    value={selectedSupportingContentWorkflow}
                    options={supportingContentWorkflowOptions}
                    onChange={handleSupportingContentWorkflowChange}
                  />
                </div>
                <div
                  style={{ width: "40%", flexShrink: 0, marginRight: "20px" }}
                >
                  <label>Description</label>
                  <Input
                    type="textarea"
                    label="Description"
                    placeholder="Description"
                    name="description"
                    value={supportingContent.description ?? ""}
                    onChange={handleChange}
                  />
                </div>
                <div style={{ width: "100%", flexShrink: 0 }}>
                  <label
                    style={{
                      display: supportingContent.workflow ? "block" : "none",
                    }}
                  >
                    Properties
                  </label>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    flexShrink: 0,
                  }}
                >
                  {displaySupportingContentTypeFields()}
                </div>
              </div>
              {activeUser && activeUser.user_type === "admin" && (
                <div>
                  <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                    <button
                      className="bg-purple-500 text-white active:bg-purple-600 font-bold uppercase text-sm px-3 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      style={{
                        display: supportingContent.workflow ? "block" : "none",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        confirmDialog({
                          message: `Are you sure you want to generate supporting content for ${supportingContent.name}?`,
                          header: "Regenerating Supporting Content",
                          icon: "pi pi-exclamation-triangle",
                          accept: () => {
                            dispatch(
                              generateSupportingContent(
                                supportingContent.public_id,
                                () => {
                                  toast.current.show({
                                    severity: "info",
                                    summary: "Generated",
                                    detail: "Generated Supporing Content",
                                    life: 3000,
                                  });
                                }
                              )
                            );
                          },
                        });
                      }}
                    >
                      generate
                    </button>
                    <button
                      className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={save}
                      disabled={savingSupportingContent}
                    >
                      {savingSupportingContent ? (
                        <>
                          <i className="fas fa-circle-notch fa-spin"></i>{" "}
                          Saving...
                        </>
                      ) : (
                        <>Save</>
                      )}
                    </button>
                  </div>
                </div>
              )}
              <Toast ref={toast} />
              <ConfirmDialog />
            </div>

            <div className="w-full px-4">
              {supportingContent?.content_type?.match(
                /(affirmations|peptalks)/
              ) ? (
                <div>
                  <AffirmationsTable
                    affirmations={supportingContent.content_items}
                  />
                </div>
              ) : (
                <div>
                  <SupportingContentTable
                    supportingContent={supportingContent.content_items}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SupportingContent;
